function NavigatorButtons({ children }) {
  return <div className="select-none m-6 flex flex-row">{children}</div>;
}

export default NavigatorButtons;
